


















































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import MyApp from "./components/myApp.vue";
import MyWork from "./components/myWork.vue";
import CService from "./components/cService/index.vue";
import cToolsDoc from "./components/cToolsDoc/index.vue";
import RightNav from "./components/rightNav/index.vue";
import solarLunar from "solarlunar";

@Component({
  name: "Home",
  components: {
    MyApp,
    MyWork,
    CService,
    cToolsDoc,
    RightNav
  }
})
export default class Home extends Base {
  private noticeSource: any[] = [];
  private systemTime: any = {};

  private created() {
    // console.log(solarLunar.solar2lunar(2021, 1, 28));
    this.getSystemTime();
    this.getNoticeList();
  }

  private async getNoticeList() {
    const res = await this.$api.NoticeList({
      pageNum: 1,
      pageSize: 3
    });
    if (res && res.code === 200) {
      this.noticeSource = res.rows;
    }
  }

  private async getSystemTime() {
    const res = await this.$api.SystemTime();
    if (res && res.code === 200) {
      const date = new Date(res.data);
      this.systemTime = solarLunar.solar2lunar(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
  }
}
